export default {
    status: {
        REGISTERED_ONLINE: 'Alta online',
        REGISTERED_EMAIL: 'Alta email',
        REGISTERED_POSTAL: 'Alta postal',
        REGISTERED: 'Alta',
        SIGNED: 'Firmada',
        VALIDATED: 'Validada',
        RD_SENT: 'Enviada a RD',
        FINALIZED: 'Finalizada'
    }
};
